import axios from "axios";

// You can manage mode via environment variables or hardcoded fallback
const MODE = import.meta.env?.VITE_APP_MODE || "DEV";

const baseUrls = {
  DEV: "https://radspeak.ai/api",
  // DEV: "http://localhost:8000",
  PROD: "https://radspeak.ai/api/",
};

export const API_BASEURL = baseUrls[MODE] || baseUrls.DEV;

const api = axios.create({
  baseURL: API_BASEURL,
  withCredentials: true,
  // timeout: 10000, // Optional: 10s timeout
});

// Request interceptor - add token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle token expiry
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
